import Marquee3k from 'marquee3000';

function loadMarquee() {
    const width = Math.max(document.clientWidth || 0, window.innerWidth || 0);
    if (width > 860) {
        jQuery(document).ready(function ($) {
            Marquee3k.init()
        });
    }
}

window.onload = loadMarquee();
window.onresize = () => loadMarquee();